var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2525_14468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2525_14468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 8 13 2.5 8 2.5C3 2.5 0 8 0 8C0 8 3 13.5 8 13.5C13 13.5 16 8 16 8ZM1.173 8C1.65652 8.73488 2.21265 9.41931 2.83301 10.043C4.12 11.332 5.88 12.5 8 12.5C10.12 12.5 11.879 11.332 13.168 10.043C13.7884 9.41931 14.3445 8.73487 14.828 8C14.3445 7.26512 13.7884 6.58068 13.168 5.957C11.879 4.668 10.119 3.5 8 3.5C5.88 3.5 4.121 4.668 2.832 5.957C2.21164 6.58069 1.65551 7.26513 1.172 8.00001L1.173 8Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.5C6.61929 5.5 5.5 6.61928 5.5 7.99999C5.5 9.3807 6.61928 10.5 7.99999 10.5C9.3807 10.5 10.5 9.38072 10.5 8.00001C10.5 6.6193 9.38072 5.50001 8.00001 5.5H8ZM4.5 8C4.5 6.74957 5.1671 5.59413 6.25 4.96891C7.3329 4.3437 8.66709 4.3437 9.75 4.96891C10.8329 5.59412 11.5 6.74957 11.5 8C11.5 9.25043 10.8329 10.4059 9.75 11.0311C8.6671 11.6563 7.3329 11.6563 6.25 11.0311C5.1671 10.4059 4.5 9.25043 4.5 8V8Z",
    fill: "#BEBEBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeOpen);
export default __webpack_public_path__ + "static/media/password-eye-open.0b1840a654385a61802b06e4e1ea4599.svg";
export { ForwardRef as ReactComponent };